import { render, staticRenderFns } from "./new_folder_modal.vue?vue&type=template&id=7626e434&"
import script from "./new_folder_modal.vue?vue&type=script&lang=js&"
export * from "./new_folder_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports